export default "__VITE_ASSET__BmbL6dR$__"